let objMovie = [
    {   // 메인
        name:"mainPlayer",
        el:"#movie-main",
        url:"_i8FUjQnIic",
        layer:"#layer-main"
    }
];

export default objMovie;


// WEBPACK FOOTER //
// ./src/js/util/movie-info.js